import { oktaAuth } from "./oktaAuth";

export const BROKER_LOGOUT_RETURN_PATH = "/login?loggedOut=1";
const BROKER_LOGOUT_MARKER_KEY = "broker-post-logout";
const BROKER_LOGOUT_CLOSE_SESSION_TIMEOUT_MS = 2000;

const getBrokerPostLogoutRedirectUri = () =>
  `${window.location.origin}${BROKER_LOGOUT_RETURN_PATH}`;

export const clearOktaAuthState = () => {
  try {
    oktaAuth.tokenManager?.clear?.();
    oktaAuth.removeOriginalUri?.();
  } catch (_error) {
    // Best-effort only; logout must continue even if local Okta state cannot be cleared.
  }
};

const getSessionStorage = () => {
  try {
    return window.sessionStorage;
  } catch (error) {
    return null;
  }
};

export const markBrokerLoggedOut = () => {
  getSessionStorage()?.setItem(BROKER_LOGOUT_MARKER_KEY, "1");
};

export const clearBrokerLoggedOut = () => {
  getSessionStorage()?.removeItem(BROKER_LOGOUT_MARKER_KEY);
};

export const hasBrokerLoggedOutMarker = () =>
  getSessionStorage()?.getItem(BROKER_LOGOUT_MARKER_KEY) === "1";

export const redirectToBrokerLoggedOut = () => {
  markBrokerLoggedOut();
  clearOktaAuthState();
  window.location.replace(BROKER_LOGOUT_RETURN_PATH);
};

export const performBrokerOktaLogout = async (idToken) => {
  markBrokerLoggedOut();
  clearOktaAuthState();

  if (idToken && typeof oktaAuth.signOut === "function") {
    try {
      await oktaAuth.signOut({
        idToken: { idToken },
        postLogoutRedirectUri: getBrokerPostLogoutRedirectUri(),
        clearTokensBeforeRedirect: true,
      });
      // Okta SDK performs the browser redirect to postLogoutRedirectUri as part
      // of the OIDC end-session flow. Do NOT call window.location.replace here —
      // a second navigation would race the Okta redirect and bypass the IdP
      // logout endpoint, leaving the Okta session alive.
      return;
    } catch (_error) {
      // signOut failed — fall through to the local fallback redirect below.
    }
  } else {
    try {
      await Promise.race([
        oktaAuth.closeSession().then(() => true),
        new Promise((resolve) => {
          setTimeout(() => resolve(false), BROKER_LOGOUT_CLOSE_SESSION_TIMEOUT_MS);
        }),
      ]);
    } catch (_error) {
      // Session close failed or timed out — proceed to redirect regardless.
    }
  }

  window.location.replace(BROKER_LOGOUT_RETURN_PATH);
};
